import {
	defAction
}from "../../../helpers/defaultAction"
import api from './api'
import {
	accountingPeriodConstants
}from "./constants"

export const accountingPeriodActions = {
	getList,
	getPaged,
	create,
	remove,
	change,
	clear
}

function getList(values){
	const dispatchObj = {
		constants : accountingPeriodConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : accountingPeriodConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : accountingPeriodConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function change(values){
	const dispatchObj = {
		constants : accountingPeriodConstants.Change,
		service   : {
			func   : api.change,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : accountingPeriodConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: accountingPeriodConstants.CLEAR
	})
}
